import React from 'react';

const FireworksAnimation: React.FC = () => {
  return (
    <div className="relative w-full h-full rounded-4xl overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('/images/home/banner.webp')`
        }}
      />
      
      {/* Feature badges with vibrant theme matching the banner */}
      <div className="absolute bottom-[30px] left-1/2 -translate-x-1/2 flex gap-3 z-10">
        <div className="bg-white/95 backdrop-blur-[10px] px-3 py-1.5 rounded-[15px] flex items-center gap-1 shadow-[0_4px_12px_rgba(244,63,94,0.2)] border border-pink-200/50">
          <span className="text-sm">🚀</span>
          <span className="text-xs font-semibold text-accent-700">Fast Delivery</span>
        </div>
        <div className="bg-white/95 backdrop-blur-[10px] px-3 py-1.5 rounded-[15px] flex items-center gap-1 shadow-[0_4px_12px_rgba(244,63,94,0.2)] border border-pink-200/50">
          <span className="text-sm">🎆</span>
          <span className="text-xs font-semibold text-accent-700">Premium Quality</span>
        </div>
        <div className="bg-white/95 backdrop-blur-[10px] px-3 py-1.5 rounded-[15px] flex items-center gap-1 shadow-[0_4px_12px_rgba(244,63,94,0.2)] border border-pink-200/50">
          <span className="text-sm">✅</span>
          <span className="text-xs font-semibold text-accent-700">Safe & Certified</span>
        </div>
      </div>
    </div>
  );
};

export default FireworksAnimation;